module.exports = __webpack_public_path__ + "static/2-39c01c77a399895dc7d55a6705dd48ff.png";